import { generator } from  '../event-listener';

export const OnBeforeClose = generator('onBeforeClose');
export const OnClose = generator('onClose');
